module.exports = __webpack_public_path__ + "static/media/session4.ae716a60.svg";